const items = document.querySelectorAll('.service-subterm');

if (items.length > 0) {
    items.forEach((item) => {
        const btn = item.querySelector('button');
        const posts = item.querySelector('.subterm-posts');

        if (btn) {
            btn.addEventListener('click', () => {
                btn.classList.toggle('service-term-btn-active');
                if (posts) {
                    posts.classList.toggle('subterm-posts-active');
                }
            });
        }
    });
}
